/**
 * CE QUE LE JOUEUR A DEVANT LUI : une page de plus, ou la dernière.
 *
 * LA CONCLUSION D'UN ATELIER EST LA DERNIÈRE PAGE DE SA PILE. Il n'y a plus de
 * page hors pile désignée par `last_page` : quand la pile se vide, le serveur
 * réaffiche la dernière page jouée sans le bouton qui fait avancer
 * (game_functions._final_page). Le bilan d'un atelier est donc une page comme
 * les autres — elle porte un bouton, et ce bouton est validé.
 *
 * D'OÙ CE MODULE. Sans lui, le dernier écran d'une séance porterait « Suivant »
 * et ne mènerait nulle part : le clic ne ferait qu'ajouter la barre de fin sous
 * un écran inchangé. C'est le pire retour possible sur l'écran qu'on projette
 * devant une salle. Le bouton doit dire ce qu'il fait — « Terminer l'atelier ».
 *
 * POURQUOI PAS SIMPLEMENT `pile.length === 1`. Parce que ce serait un mensonge
 * dès qu'une page peut en ajouter derrière elle. Valider une page à décisions
 * PRÉFIXE ses conséquences à la pile (`update_decision_page`) : la grille qui
 * clôt la pile peut très bien être suivie de trois pages, selon ce que la salle
 * a coché. La règle est donc volontairement étroite — on n'annonce la fin que
 * lorsqu'elle est certaine — et son défaut est de ne rien annoncer dans le
 * doute, ce qui ramène au comportement d'avant.
 */

/** Le libellé du bouton qui fait avancer. */
export function nextLabel(endsGame) {
  return endsGame ? "Terminer l'atelier" : 'Suivant';
}

/**
 * `true` si valider CETTE page termine la séance, à coup sûr.
 *
 * Trois conditions, chacune nécessaire :
 *  - c'est le dernier élément de la pile (`game_status.pile` porte la page
 *    courante en tête, donc « dernier » = pile de longueur 1) ;
 *  - la page ne porte pas de décisions — leurs conséquences s'ajoutent à la
 *    pile, et elles dépendent de ce qui sera coché ;
 *  - elle ne déclare aucune `page_general_consequence`. Le serveur les ignore
 *    aujourd'hui pour les pages sans décision (`update_no_action_page` se
 *    contente de dépiler), mais s'appuyer là-dessus ferait de ce libellé la
 *    victime silencieuse du jour où ce trou sera bouché.
 */
export function isTerminalPage(pageData, gameStatus) {
  if (!pageData || !gameStatus) return false;
  if ((gameStatus.pile || []).length !== 1) return false;
  if ((pageData.page_general_consequence || []).length > 0) return false;
  if ((pageData.content?.list_decisions || []).length > 0) return false;
  return true;
}
